(() => {
  const closeMenus = () => document.querySelectorAll('.nk-mobile-menu[open]').forEach(menu => menu.removeAttribute('open'));
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') {
      document.querySelectorAll('.nk-mobile-menu[open]').forEach(menu => {
        menu.removeAttribute('open');
        menu.querySelector('summary').focus();
      });
    }
  });
  document.addEventListener('click', event => {
    if (!event.target.closest('.nk-mobile-menu')) closeMenus();
    if (event.target.closest('.nk-mobile-menu a')) closeMenus();
  });
  document.querySelectorAll('[data-nk-variant-select]').forEach(select => {
    select.addEventListener('change', () => {
      const option = select.selectedOptions[0];
      const root = select.closest('.nk-product__info');
      const price = root?.querySelector('[data-nk-product-price]');
      if (price) price.textContent = option.dataset.price;
      const button = select.closest('form').querySelector('[data-nk-purchase-button]');
      if (button) {
        button.disabled = option.dataset.available !== 'true';
        button.textContent = button.disabled ? button.dataset.soldOut : button.dataset.availableLabel;
      }
    });
  });
  const contactTopic = document.getElementById('ContactTopic');
  if (contactTopic) {
    const requestedTopic = new URLSearchParams(location.search).get('emne');
    const matchingTopic = Array.from(contactTopic.options).find(option => option.dataset.topic === requestedTopic || option.dataset.query === requestedTopic);
    if (matchingTopic) contactTopic.value = matchingTopic.value;
  }
  const initConsent = () => {
    if (!window.privacyBanner?.showPreferences) return;
    document.querySelectorAll('[data-nk-cookie-preferences]').forEach(button => {
      button.hidden = false;
      if (button.dataset.bound) return;
      button.dataset.bound = 'true';
      button.addEventListener('click', () => window.privacyBanner.showPreferences());
    });
  };
  initConsent();
  window.addEventListener('load', initConsent, { once: true });
  document.addEventListener('visitorConsentCollected', initConsent, { once: true });
  const bar = document.querySelector('[data-nk-mobile-purchase]');
  const form = document.getElementById(bar?.dataset.nkStickyForm || 'NkProductForm');
  if (bar && form && 'IntersectionObserver' in window) {
    new IntersectionObserver(entries => {
      bar.classList.toggle('nk-mobile-purchase--visible', !entries[0].isIntersecting);
    }, { threshold: 0 }).observe(form);
  }
})();
